import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CrmApiClient, CrmApiClientFactory } from '../../../services/crm/client';

function cleanText (text:string) {
  return text
    .normalize("NFD")                    // Separa letras de acentos
    .replace(/[\u0300-\u036f]/g, "")     // Elimina los acentos
    .replace(/\s+/g, "_")                // Reemplaza espacios por _
}

export const useFetchData = (setScriptData: (data: any) => void, scriptData: any, setLoading: any) => {
  const navigate = useNavigate();
  
  const fetchClapperCatalog = async () => {
    try {
      const response = await fetch("https://djadx63cv2.execute-api.eu-west-1.amazonaws.com/clapperCatalog");
      const data = await response.json();
      const projectId = document.getElementById('project-title')?.innerText || '';
      return data.filter((item: any) => item.script_id === cleanText(projectId));
    } catch (error) {
      console.error("Error querying the database:", error);
      return {};
    }
  }
  
  const fetchScriptLines = async () => {
    try {
      const response = await fetch("https://djadx63cv2.execute-api.eu-west-1.amazonaws.com/scriptLines");
      const data = await response.json();
      const projectId = document.getElementById('project-title')?.innerText || '';
      return data.filter((item: any) => item.script_id === cleanText(projectId));
    } catch (error) {
      console.error("Error querying the database:", error);
      return {};
    }
  }

  const fetchRecordings = async () => {
    try {
      const crmApiClient: CrmApiClient = CrmApiClientFactory(navigate);
      const data = await crmApiClient.getRecordings();
      return data;

    } catch (error) {
      console.error("Error querying the API:", error);
      return {};
    }
  }

  const getCompleteRecordingsArray = (recordings: any, clapperCatalog: any) => {
    const recordingsArray = Array.isArray(recordings) ? recordings : [];
    const completeRecordings: any[] = [];
    
    recordingsArray.forEach((recording) => {
      const clapperCatalogMatch = clapperCatalog.find((item: any) => item.video_name.includes(recording.name));
      completeRecordings.push({ ...recording, ...clapperCatalogMatch });
    });

    const completeRecordingsArray = Array.isArray(completeRecordings) ? completeRecordings : [];
    return completeRecordingsArray;
  }

  const getSequences = (clapperCatalog: any) => {
    const rawSequences = clapperCatalog.map((item: any) => item.sequence);
    const uniqueSequences = Array.from(new Set(rawSequences));
    const sequences = (Array.isArray(uniqueSequences) ? uniqueSequences : []) as (string | number)[];
    sequences.sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));
    return sequences;
  };

  const getPlanes = (clapperCatalog: any) => {
    const rawPlanes = clapperCatalog.map((item: any) => ({ sequence: item.sequence, plane: item.plane }));
    const uniquePlanes = Array.from(new Set(rawPlanes.map((p: any) => JSON.stringify(p)))).map((s: any) => JSON.parse(s));
    uniquePlanes.sort((a: any, b: any) => {
      const seqComp = String(a.sequence).localeCompare(String(b.sequence), undefined, { numeric: true });
      if (seqComp !== 0) {
        return seqComp;
      }
      return String(a.plane).localeCompare(String(b.plane), undefined, { numeric: true });
    });
    return uniquePlanes;
  };

  const getTakes = (clapperCatalog: any) => {
    const rawTakes = clapperCatalog.map((item: any) => ({ sequence: item.sequence, plane: item.plane, take: item.take }));
    const uniqueTakes = Array.from(new Set(rawTakes.map((t: any) => JSON.stringify(t)))).map((s: any) => JSON.parse(s));
    uniqueTakes.sort((a: any, b: any) => {
      const seqComp = String(a.sequence).localeCompare(String(b.sequence), undefined, { numeric: true });
      if (seqComp !== 0) return seqComp;
      const planeComp = String(a.plane).localeCompare(String(b.plane), undefined, { numeric: true });
      if (planeComp !== 0) return planeComp;
      return String(a.take).localeCompare(String(b.take), undefined, { numeric: true });
    });
    return uniqueTakes;
  }

  const fetchData = async () => {
    setLoading(true);
    const clapperCatalog = await fetchClapperCatalog();
    const recordings = await fetchRecordings();
    const scriptLines = await fetchScriptLines();
    const completeRecordingsArray = getCompleteRecordingsArray(recordings, clapperCatalog);
    const sequences = getSequences(clapperCatalog);
    const planes = getPlanes(clapperCatalog);
    const takes = getTakes(clapperCatalog);
    setLoading(false);
    setScriptData({
      clapperCatalog,
      recordings: completeRecordingsArray,
      currentRecording: null,
      sequences,
      planes,
      takes,
      scriptLines,
    });
  }
  
  useEffect(() => {
    if(!scriptData) {
      try {
        fetchData();
      } catch {
        setLoading(false);
      }
      
    }
  }, [fetchData]);
};
